import Vue from 'vue'
import Router from 'vue-router'
import { formatRoutes } from '@/utils/routerUtil'

Vue.use(Router)

const originalPush = Router.prototype.push
// 解决重复点路由报错问题
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 不需要登录拦截的路由配置
const loginIgnore = {
  paths: ['/login', '/jump'], //根据路由fullPath匹配
  /**
   * 判断路由是否包含在该配置中
   * @param route vue-router 的 route 对象
   * @returns {boolean}
   */
  includes(route) {
    return this.paths.includes(route.path)
  },
}

const options = require('./async/config.async').default
formatRoutes(options.routes)
const initRouter = new Router({
  mode: 'history',
  ...options,
})

export { loginIgnore, initRouter }
